import { SanityModule } from '@data/sanity/queries/types/modules'

const heroModuleTypes = ['hero', 'heroCaseVideoCarousel']

/**
 * Gets page modules without hero module.
 */
export const getFilteredPageModules = (modules: SanityModule[]) => {
  return modules
    .filter((module, index) => {
      return index > 0 || !heroModuleTypes.includes(module._type)
    })
    .filter(Boolean)
}

/**
 * Gets hero page modules.
 */
export const getFilteredHeroModules = (modules: SanityModule[]) => {
  return modules
    .filter((module, index) => {
      return index === 0 && heroModuleTypes.includes(module._type)
    })
    .filter(Boolean)
}
